import { SixPageWrapper } from '../../components/SixPageWrapper/SixPageWrapper';
import { MenuItems } from '../../types/MenuItems';
import { SixSectionWrapper } from '../../components/SixSectionWrapper/SixSectionWrapper';
import { getTranslation } from '../../constants/translations';

import image1 from '../../assets/images/finance/finance_page_1.png';
import image2 from '../../assets/images/finance/finance_page_2.png';
import image3 from '../../assets/images/finance/finance_page_3.png';
import image4 from '../../assets/images/finance/finance_page_4.png';
import image5 from '../../assets/images/finance/finance_page_5.png';

import './Finance.scss';

const images = [image1, image2, image3, image4, image5];

export const Finance = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const t = getTranslation();

  return (
    <>
      <SixPageWrapper
        section={MenuItems.FINANCE}
        title={t.FINANCE.title}
        itemsList={t.FINANCE.subsections.map((ss, i) => ({
          ...ss,
          link: `#${MenuItems.FINANCE}-page-${i + 1}`,
        }))}
      />

      {t.FINANCE.subsections.map((subsection, i) => (
        <SixSectionWrapper
          key={i}
          id={`${MenuItems.FINANCE}-page-${i + 1}`}
          color={style.getPropertyValue('--light-blue')}
          imgURL={images[i]}
          title={subsection.title}
          textContent={subsection.content}
        />
      ))}
    </>
  );
};
